import Layout from '@/components/layout/Layout.vue'
import LocalMaterial from '@/components/local-material/LocalMaterial.vue'

export default {
    name: 'local_material',
    components: {
        Layout,
        LocalMaterial,
    },
    data() {
        return {
           
        }
    },
    mounted() {
    },
    methods: {
        
    }
}
